export default __webpack_public_path__ + "static/media/Logo.b9742380.svg";